import { ShieldAlert } from 'lucide-react';
import { Card } from './Card';
import { Button } from './Button';

export function NoPermission({ role = 'admin', message, actionLabel, actionTo }) {
    return (
        <Card variant="muted" padding="p-10 sm:p-14" className="text-center max-w-lg mx-auto mt-10">
            <div className="mb-5 flex justify-center">
                <span className="inline-flex h-16 w-16 items-center justify-center rounded-xl bg-red-100 text-red-600">
                    <ShieldAlert size={32} />
                </span>
            </div>
            <h2 className="text-xl font-bold text-gray-900">Access Restricted</h2>
            <p className="mt-2 text-sm text-gray-500 max-w-sm mx-auto">
                {message || `You do not have permission to access this ${role} area.`}
            </p>
            {actionTo && (
                <div className="mt-6">
                    <Button to={actionTo} variant="primary" size="lg">{actionLabel || 'Go Home'}</Button>
                </div>
            )}
        </Card>
    );
}
